/**
 * Compares two values for form dirty detection. Handles:
 * - Strict and loose equality
 * - null/undefined equivalence
 * - String trimming
 * - Numeric coercion (0, "0", 0.0 treated as equal - fixes 0→1→0 staying highlighted)
 */
export const isValueDifferent = (
  defaultValue: unknown,
  currentValue: unknown,
): boolean => {
  // Fast path: strict equality
  if (defaultValue === currentValue) {
    return false;
  }

  // null/undefined are equivalent
  if (defaultValue == null && currentValue == null) {
    return false;
  }

  // Loose equality (e.g. 0 == "0")
  if (defaultValue == currentValue) {
    return false;
  }

  // String comparison (trimmed)
  const defaultStr = String(defaultValue ?? "").trim();
  const currentStr = String(currentValue ?? "").trim();

  if (defaultStr === currentStr) {
    return false;
  }

  // Numeric comparison: 0, "0", 0.0 all equivalent
  const defaultNum = Number(defaultStr);
  const currentNum = Number(currentStr);

  if (!Number.isNaN(defaultNum) && !Number.isNaN(currentNum)) {
    return defaultNum !== currentNum;
  }

  return defaultStr !== currentStr;
};
